// extracted by mini-css-extract-plugin
export default {"input":"Sqa-z","button":"Tqa-z","selected":"Uqa-z","sephoraImage":"Vqa-z","unavailable":"Wqa-z","image":"Xqa-z"};